import { ReactSelectInstanceRefObject } from '../../custom-react-select.types';

type Params = {
  selectRef: ReactSelectInstanceRefObject;
};

const handleScrollAfterSelect = ({ selectRef }: Params) => {
  setTimeout(() => {
    const select = selectRef?.current;
    if (!select) return;
    const controlRef = select?.controlRef as HTMLElement | null;
    if (!controlRef) return;
    const valueContainer = controlRef.querySelector('.truncated-creatable-multi-react-select__value-container');
    if (!valueContainer) return;
    const scrollAmount = valueContainer.scrollWidth;
    valueContainer.scrollTo({
      left: scrollAmount,
      behavior: 'smooth',
    });
  }, 0);
};
export default handleScrollAfterSelect;
